import * as React from 'react';
import withStyles from 'react-jss';
import { StylesProps, KeyLabel } from 'src/Library/Types';
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Icon from 'antd/lib/icon';
import Select from 'antd/lib/select';
import Checkbox from 'antd/lib/checkbox';
import message from 'antd/lib/message';
import Collapse from 'antd/lib/collapse';
import Spin from 'antd/lib/spin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAllDataSetFilter } from 'src/actions/discoverRatesActions';
import { InquiryConfirmationModalStyles } from './InquiryConfirmationModal.styles';
import { SearchFilters } from './TypesInDiscoverRates/SearchFilters';
import {
  FFSelectedText,
  FFType,
  FFSelectedSendInquiry,
  FFStrategicText,
  FFStrategicSendInquiry,
} from './DiscoverRateUtils';
import { SelectedFilters, OrganisationList } from './TypesInDiscoverRates/SelectedFilters';
import { isValidArray, clone } from 'src/Library/Helper';
import { useGenericState } from 'src/Library/UseGenericState';
import {
  fetchFFsAndGroups,
  renderSelectDropDown,
  fetchStrategicVendorList,
} from 'src/Library/Common';
import { setCreateInquiryData } from 'src/actions/inquiryShipperActions';
import RouteInfoWithFlag from './RouteInfoWithFlag';
import { arrayToObject } from 'src/utils/utils';
import { FFAndGroup } from 'src/components/common/Types/CommonTypes';
import uniqWith from 'lodash/uniqWith';

interface FFSelectionModalProps
  extends StylesProps<ReturnType<typeof InquiryConfirmationModalStyles>> {
  isVisible: boolean;
  onModalClose: () => void;
  getAllDataSetFilter: (val, apiCall?: boolean) => void;
  searchFilters: SearchFilters;
  selectedFilters: SelectedFilters;
  setCreateInquiryData: (val) => void;
  handleFFSelectionSend: (ffList, groupList, strategicFFs) => void;
  isLoading: boolean;
  showDiscoverBuyRates: boolean;
  hideStrategicVendors: boolean;
  fromSendInquiryDiscoverRates: boolean;
  ffList: any[];
  searchResults: any;
}

interface FFList {
  orgId: string;
  linkingStatus: string;
}

interface OrgData {
  freightChargeId: string;
  originChargeId: string;
  destinationChargeId: string;
  criteriaId: string;
  criteriaRuleId: string;
  orgName: string;
  orgId: string;
  linkingStatus: string;
}

interface StateProps {
  linkedFFs: FFAndGroup[];
  fetchingFFs: boolean;
  selectAll: boolean;
  selectAllStrategicFFs: boolean;
  selectedFFs: KeyLabel[];
  selectedStrategicFFs: KeyLabel[];
  orgList: OrganisationList[];
  strategicFFs: KeyLabel[];
  RateFFs: KeyLabel[];
  selectedRateFFs: KeyLabel[];
  selectedAllRateFFs: boolean;
}

const FFSelectionModal = (props: FFSelectionModalProps): React.ReactElement => {
  const {
    isVisible,
    onModalClose,
    classes,
    getAllDataSetFilter,
    searchFilters,
    selectedFilters,
    handleFFSelectionSend,
    isLoading,
    showDiscoverBuyRates,
    hideStrategicVendors,
    fromSendInquiryDiscoverRates,
    ffList,
    searchResults,
  } = props;

  const [state, setState] = useGenericState<StateProps>({
    linkedFFs: [],
    fetchingFFs: false,
    selectAll: false,
    selectedFFs: [],
    orgList: selectedFilters?.organisationList || [],
    strategicFFs: [],
    selectedStrategicFFs: [],
    selectAllStrategicFFs: false,
    RateFFs: [],
    selectedRateFFs: [],
    selectedAllRateFFs: false,
  });

  const {
    linkedFFs,
    fetchingFFs,
    selectAll,
    selectedFFs,
    orgList,
    strategicFFs,
    selectedStrategicFFs,
    selectAllStrategicFFs,
    RateFFs,
    selectedRateFFs,
    selectedAllRateFFs,
  } = state;

  React.useEffect(() => {
    fetchFFs();
  }, []);

  const renderLinkingStatus = (linkingStatus) => {
    switch (linkingStatus) {
      case 'NON_LINKED':
        return 'Non-Linked';
      default:
        return;
    }
  };

  const handleRemoveFF = (ffId) => {
    const filteredFF = orgList?.filter((ff) => ff?.orgId !== ffId);
    setState({ orgList: filteredFF });
  };

  const getUniqueOrgNames = () => {
    const organisationList: OrganisationList[] = isValidArray(orgList)
      ? uniqWith(orgList, (a, b) => a.orgId === b.orgId)
      : [];
    return organisationList;
  };

  const getOrgData = (data, ffList) => {
    const {
      ffOrganisation,
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
    } = data;
    return {
      freightChargeId,
      originChargeId,
      destinationChargeId,
      criteriaId,
      criteriaRuleId,
      orgName: ffOrganisation?.name,
      orgId: ffOrganisation?.id,
      linkingStatus: ffList[data?.ffOrganisation?.id]?.linkingStatus,
    };
  };

  const getAllRateSelectedFF: () => OrgData[] = () => {
    const list: OrgData[] = [];
    const ffListObj: { [id: string]: {} } = {};
    ffList.forEach((item) => (ffListObj[item.id] = item));
    searchResults.forEach((data) => {
      list.push(getOrgData(data, ffListObj));
    });
    return list;
  };

  const renderSelectedFFsDropDown = () => {
    return (
      isValidArray(RateFFs) && (
        <React.Fragment>
          {renderSelectAnotherFFs(FFType.RATE_FF)}
          {isValidArray(RateFFs) && renderAnotherFFs(selectedRateFFs, 'selectedRateFFs')}
        </React.Fragment>
      )
    );
  };

  const renderSelectedFFs = (): React.ReactElement => {
    const uniqueOrg = getUniqueOrgNames();
    return (
      <div style={{ marginBottom: '12px' }} className={classes.ffList}>
        {isValidArray(uniqueOrg) &&
          uniqueOrg?.map((ff) => (
            <Row className={classes.ffRow}>
              <Col span={14}>{ff?.orgName}</Col>
              <Col span={9} className={classes.status}>
                {renderLinkingStatus(ff?.linkingStatus)}
              </Col>
              <Col span={1} className={classes.closeIcon}>
                {ff?.linkingStatus === 'NON_LINKED' && (
                  <Icon type="close" onClick={() => handleRemoveFF(ff?.orgId)} />
                )}
              </Col>
            </Row>
          ))}
      </div>
    );
  };

  const getOrgList = () => {
    return isValidArray(selectedFilters?.organisationList)
      ? selectedFilters?.organisationList.map((org) => org.orgId)
      : [];
  };

  const fetchFFs = async (): Promise<void> => {
    const orgList = getOrgList();
    setState({ fetchingFFs: true });
    const RateFFsSet: Set<string> = new Set();
    const RateFFs = ffList.map((data) => {
      RateFFsSet.add(data.id);
      return { key: data.id, label: data.name };
    });
    let ffs = await fetchFFsAndGroups('FF', 'FCL');
    ffs = ffs.filter((ff) => orgList.indexOf(ff.key) === -1 && !RateFFsSet.has(ff.key));
    setState({
      linkedFFs: ffs,
      fetchingFFs: false,
      RateFFs,
    });
    getStrategicFFs(ffs);
  };

  const getStrategicFFs = async (fetchedFFs): Promise<void> => {
    const orgList = getOrgList();
    const ffList = fetchedFFs?.map((item) => item.key);
    setState({ fetchingFFs: true });
    const ffs: KeyLabel[] = showDiscoverBuyRates && !hideStrategicVendors
      ? await fetchStrategicVendorList(ffList, orgList, 'FCL')
      : [];
    setState({
      strategicFFs: ffs,
      fetchingFFs: false,
    });
  };

  const renderSelectFFsOptions = (type, ffList, selectedFFList) => {
    return ffList?.map((ff) => (
      <Select.Option style={{ display: 'flex' }} key={ff.key} data-value={ff.label}>
        <Checkbox
          key={ff.key}
          checked={
            selectedFFList?.some((item) => item.key === ff.key) ||
            getValueFromKeyMap(type, 'isSelectAll')
          }
          style={{ marginRight: '10px' }}
        />
        <span className={classes.ffOptions}>
          {ff.label}
          {ff.isGroup && <span className={classes.group}>Group</span>}
        </span>
      </Select.Option>
    ));
  };

  const getValueFromKeyMap = (type: string, option: string) => {
    let keyMap;
    if (type === FFType.STRATEGIC_FF) {
      keyMap = {
        selectedList: 'selectedStrategicFFs',
        isSelectAll: selectAllStrategicFFs,
        isSelectAllKey: 'selectAllStrategicFFs',
        ffList: strategicFFs,
        selectedFFList: selectedStrategicFFs,
      };
    } else if (type === FFType.RATE_FF) {
      keyMap = {
        selectedList: 'selectedRateFFs',
        isSelectAll: selectedAllRateFFs,
        isSelectAllKey: 'selectedAllRateFFs',
        ffList: RateFFs,
        selectedFFList: selectedRateFFs,
      };
    } else {
      keyMap = {
        selectedList: 'selectedFFs',
        isSelectAll: selectAll,
        isSelectAllKey: 'selectAll',
        ffList: linkedFFs,
        selectedFFList: selectedFFs,
      };
    }
    return keyMap[option];
  };

  const handleSelectFFs = (options, ffList, selectedFFList, type) => {
    const selectedList = getValueFromKeyMap(type, 'selectedList');
    const isSelectAll = getValueFromKeyMap(type, 'isSelectAll');
    const isSelectAllKey = getValueFromKeyMap(type, 'isSelectAllKey');

    if (options[0]?.key === 'all') {
      setState({
        [isSelectAllKey]: !isSelectAll,
        [selectedList]: !isSelectAll && isValidArray(ffList) ? clone(ffList) : [],
      });
    } else {
      const ffs = isValidArray(selectedFFList) ? clone(selectedFFList) : [];
      const ffSelected = selectedFFList.some((ff) => ff.key === options[0]?.key);
      if (ffSelected) {
        const selectedFFList = isValidArray(ffs)
          ? ffs.filter((ff) => ff.key !== options[0]?.key)
          : [];
        setState({
          [selectedList]: selectedFFList,
          [isSelectAllKey]: false,
        });
      } else {
        setState({
          [isSelectAllKey]: false,
          [selectedList]: [
            ...ffs,
            {
              key: options[0]?.key,
              label: options[0]?.props?.children[1]?.props?.children[0],
            },
          ],
        });
      }
    }
  };

  const renderSelectAnotherFFs = (type) => {
    const ffList = getValueFromKeyMap(type, 'ffList');
    const selectedFFList = getValueFromKeyMap(type, 'selectedFFList');
    const isSelectAll = getValueFromKeyMap(type, 'isSelectAll');
    return (
      <div className={classes.selectAnotherFF} style={{ width: '88%' }}>
        <Select
          mode="multiple"
          getPopupContainer={(trigger: any) => trigger.parentNode}
          style={{ width: '100%' }}
          className={classes.select}
          showSearch
          allowClear
          showArrow
          optionFilterProp={'data-value'}
          placeholder="Search & Select Forwarder(s)"
          value={[]}
          onChange={(filtervals, options) => handleSelectFFs(options, ffList, selectedFFList, type)}
          dropdownRender={(menu) => renderSelectDropDown(menu, fetchingFFs)}
        >
          <Select.Option key="all">
            <Checkbox key="all" style={{ marginRight: '10px' }} checked={isSelectAll} />
            Select All
          </Select.Option>
          {renderSelectFFsOptions(type, ffList, selectedFFList)}
        </Select>
      </div>
    );
  };

  const handleRemoveAnotherFF = (ff, selectedFFList, selectedFF) => {
    let ffList = isValidArray(selectedFFList) ? clone(selectedFFList) : [];
    ffList = ffList?.filter((item) => item.key !== ff.key);
    let isSelectAll;
    switch (selectedFF) {
      case 'selectedStrategicFFs':
        isSelectAll = 'selectAllStrategicFFs';
        break;
      case 'selectedRateFFs':
        isSelectAll = 'selectedAllRateFFs';
        break;
      default:
        isSelectAll = 'selectAll';
    }
    setState({ [selectedFF]: ffList, [isSelectAll]: false });
  };

  const renderAnotherFFs = (selectedFFList, selectedFF) => {
    return (
      <div className={classes.ffList} style={{ width: '88%' }}>
        {selectedFFList?.map((ff) => (
          <div className={classes.anotherFFs}>
            <span>{ff.label}</span>
            <Icon
              type="close"
              onClick={() => handleRemoveAnotherFF(ff, selectedFFList, selectedFF)}
            />
          </div>
        ))}
      </div>
    );
  };

  const handleNext = async () => {
    if (
      !isValidArray(orgList) &&
      !isValidArray(selectedFFs) &&
      !isValidArray(selectedStrategicFFs) &&
      !isValidArray(selectedRateFFs)
    ) {
      message.error('Please select at least one Freight Forwarder');
    } else {
      await getAllDataSetFilter({ organisationList: orgList }, false);
      const linkedFFsMap = arrayToObject(linkedFFs, 'key');
      let groupList: string[] = [];
      const ffList: FFList[] = [];
      if (fromSendInquiryDiscoverRates) {
        const AllOrgData = getAllRateSelectedFF();
        let SelectedRateFFIds: Set<string> = new Set();
        selectedRateFFs.forEach((item) => {
          SelectedRateFFIds.add(item.key);
        });
        AllOrgData.forEach((data) => {
          if (SelectedRateFFIds.has(data.orgId)) ffList.push(data);
        });
      }

      isValidArray(selectedFFs)
        ? selectedFFs.map((item) => {
            if (linkedFFsMap[item.key]?.isGroup) {
              groupList.push(item.key);
            } else {
              ffList.push({
                orgId: item.key,
                linkingStatus: 'LINKED',
              });
            }
          })
        : [];
      const strategicFFs = selectedStrategicFFs?.map((item) => item.key) || [];
      handleFFSelectionSend(ffList, groupList, strategicFFs);
    }
  };

  const renderFFSelectionHeader = (title, item): React.ReactElement => {
    return (
      <div className={classes.selectedFFsPanel}>
        <span>{title}</span>
        {isValidArray(item) && <span>({item?.length})</span>}
      </div>
    );
  };

  const renderSelectedFFsCollapse = () => (
    <Collapse.Panel
      header={renderFFSelectionHeader(
        fromSendInquiryDiscoverRates ? FFSelectedSendInquiry : FFSelectedText,
        getUniqueOrgNames()
      )}
      className={classes.ffSelectionBorder}
      key="1"
    >
      {fromSendInquiryDiscoverRates ? renderSelectedFFsDropDown() : renderSelectedFFs()}
    </Collapse.Panel>
  );

  const renderStrategicFFs = () =>
    isValidArray(strategicFFs) &&
    showDiscoverBuyRates && !hideStrategicVendors && (
      <Collapse.Panel
        header={renderFFSelectionHeader(
          fromSendInquiryDiscoverRates ? FFStrategicSendInquiry : FFStrategicText,
          selectedStrategicFFs
        )}
        key="3"
        className={classes.ffSelectionBorder}
      >
        {renderSelectAnotherFFs(FFType.STRATEGIC_FF)}
        {isValidArray(selectedStrategicFFs) &&
          renderAnotherFFs(selectedStrategicFFs, 'selectedStrategicFFs')}
      </Collapse.Panel>
    );

  const renderMyForwarders = () =>
    isValidArray(linkedFFs) && (
      <Collapse.Panel
        className={classes.ffSelectionBorder}
        header={renderFFSelectionHeader(
          fromSendInquiryDiscoverRates ? 'My FFs with no rates' : 'My Forwarder(s)',
          selectedFFs
        )}
        key="2"
      >
        {renderSelectAnotherFFs(FFType.MY_FF)}
        {isValidArray(selectedFFs) && renderAnotherFFs(selectedFFs, 'selectedFFs')}
      </Collapse.Panel>
    );

  const renderFFSelection = (): React.ReactElement => {
    return (
      <Collapse
        accordion
        defaultActiveKey={fromSendInquiryDiscoverRates ? '2' : '1'}
        className={classes.collapseDiv}
      >
        {fromSendInquiryDiscoverRates ? renderStrategicFFs() : renderSelectedFFsCollapse()}
        {renderMyForwarders()}
        {!fromSendInquiryDiscoverRates ? renderStrategicFFs() : renderSelectedFFsCollapse()}
      </Collapse>
    );
  };

  return (
    <Modal
      visible={isVisible}
      zIndex={1000}
      className={classes.ffModal}
      title="Freight Forwarder Selection"
      closable={false}
      onCancel={onModalClose}
      footer={
        <React.Fragment>
          <Button
            className={classes.cancelFFButton}
            onClick={() => {
              onModalClose();
            }}
          >
            Cancel
          </Button>
          <Button
            className={classes.nextButton}
            loading={isLoading}
            onClick={() => {
              handleNext();
            }}
          >
            Send
          </Button>
        </React.Fragment>
      }
    >
      <RouteInfoWithFlag
        origin={searchFilters.pol}
        destination={searchFilters.pod}
        portStyle={true}
      />
      {renderFFSelection()}
      {showDiscoverBuyRates && !hideStrategicVendors && fetchingFFs && <Spin style={{ margin: '10px 45%' }} />}
    </Modal>
  );
};

const mapStateToProps = ({ discoverRatesReducer, masterData }, ownProps) => ({
  searchFilters: discoverRatesReducer.searchFilters,
  selectedFilters: discoverRatesReducer.selectedFilters,
  showDiscoverBuyRates: masterData.modules.show_discover_buy_rates,
  hideStrategicVendors: masterData.modules.hide_strategic_vendors,
  ffList: discoverRatesReducer.ffList,
  searchResults: discoverRatesReducer.searchResults,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getAllDataSetFilter,
      setCreateInquiryData,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(InquiryConfirmationModalStyles)(FFSelectionModal));
